import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgUnlocked = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M7.55556 11.0998V7.50071C7.55445 6.38504 7.96292 5.30874 8.70167 4.48077C9.44041 3.6528 10.4567 3.13223 11.5533 3.0201C12.6499 2.90798 13.7486 3.21231 14.636 3.87401C15.5234 4.53571 16.1362 5.50758 16.3556 6.60094M5.77778 11.0998H18.2222C19.2041 11.0998 20 11.9055 20 12.8994V19.1978C20 20.1916 19.2041 20.9973 18.2222 20.9973H5.77778C4.79594 20.9973 4 20.1916 4 19.1978V12.8994C4 11.9055 4.79594 11.0998 5.77778 11.0998Z",
		stroke: "currentColor",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
const ForwardRef = forwardRef(SvgUnlocked);
export { ForwardRef as ReactComponent };
